import { chatpayload, responsePayload } from "../modules/types/chatbot.model.ts"
import axiosInstance from "./axiosInstance.ts";

export const chatbot = {
  chatbotInstruction: (question: chatpayload) => axiosInstance.post(`/chatbot/chat_bot`, question),
  chatbotHistory: (dataset_id: number, file_id?: number) => {
    if (file_id !== undefined) {
      return axiosInstance.get(`/chatbot/get_history_by_user_id?dataset_id=${dataset_id}&file_id=${file_id}`);
    } else {
      return axiosInstance.get(`/chatbot/get_history_by_user_id?dataset_id=${dataset_id}`);
    }
  },  downloadCSV: (chat_id: number) => axiosInstance.post(`/chatbot/download_csv`,{chat_id}),
  chatbotResponseWorkshop: (responsePayload: responsePayload, acronym) => axiosInstance.post(`workshop/chatbot/response/?acronym=${acronym}`, responsePayload),
};
